import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "../../utils/cn";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <SwitchPrimitive.Root
      ref={ref}
      data-slot="switch"
      className={cn(
        // track
        "peer relative inline-flex h-6 w-11 shrink-0 items-center overflow-hidden rounded-full",
        "border border-transparent shadow-xs outline-none transition-all",
        "focus-visible:ring-[3px] focus-visible:ring-ring/50",
        "disabled:cursor-not-allowed disabled:opacity-50",
        // colors
        "data-[state=checked]:bg-xuron-orange",
        "data-[state=unchecked]:bg-gray-200",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          // thumb (smaller than track)
          "pointer-events-none block h-5 w-5 rounded-full bg-white ring-0 border border-gray-200",
          "shadow-sm transition-transform",
          // keep inside: start with a small left inset, end with a small right inset
          "translate-x-0 data-[state=checked]:translate-x-5"
        )}
      />
    </SwitchPrimitive.Root>
  );
});
Switch.displayName = "Switch";

export { Switch };
